import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-cream relative overflow-hidden" data-id="element-223">
      <div className="max-w-3xl mx-auto text-center" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-225">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brown mb-12" data-id="element-226">
            Para la mamá que está agotada de pelear con la persona que más ama.
          </h2>

          <div className="space-y-8 text-xl md:text-2xl text-brown-light leading-relaxed font-serif" data-id="element-227">
            <p data-id="element-228">Tú no elegiste esto.</p>

            <p data-id="element-229">
              No elegiste que cada decisión sobre el bebé se convierta en una
              negociación tensa. No elegiste sentirte sola en la misma casa que
              tu pareja. No elegiste que el cansancio se transforme en
              resentimiento.
            </p>

            <p className="font-bold text-brown" data-id="element-230">Pero aquí estás.</p>

            <p className="text-lg md:text-xl italic" data-id="element-231">
              Discutiendo por el chupete. Por los horarios. Por las visitas. Por
              quién se levanta. Por quién hace más. Por quién está más cansado.
            </p>

            <p className="font-bold text-brown pt-4" data-id="element-232">
              Y lo peor no son las peleas.
            </p>

            <div className="pt-8" data-id="element-233">
              <p className="text-2xl md:text-3xl font-bold text-terracotta" data-id="element-234">
                Es el miedo silencioso de que esto sea "la nueva normalidad".
              </p>
              <p className="text-2xl md:text-3xl font-bold text-brown mt-4" data-id="element-235">
                De que el bebé haya traído amor a la casa, pero se haya llevado
                la conexión de pareja.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}